import { useMemo } from "react";
import { marked } from "marked";
import { sanitizeChapterHtml } from "@/zapi-frontend/shared/lib/chapterHtml";
import { markFigureSpans } from "@/zapi-frontend/shared/lib/figureRefs";
import type { TProseBlock } from "@/zapi-frontend/shared/types/contentBlocks";
import { useFigureRefs } from "./FigureRefs/FigureRefsProvider";
import { memoType } from "./memoTypography";
import { cn } from "@/zapi-frontend/shared/lib/utils";

export function ProseBlock({ block }: { block: TProseBlock }) {
  const refs = useFigureRefs();
  const html = useMemo(() => {
    const marked_ = refs ? markFigureSpans(block.text, block.refs, refs) : block.text;
    return sanitizeChapterHtml(marked.parse(marked_, { async: false }));
  }, [block.text, block.refs, refs]);
  return (
    <div
      className={cn(
        "[&_p]:mb-3 [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-[22.5px] [&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:pl-[22.5px] [&_a]:text-innoveraOrange-400 [&_a]:underline [&_strong]:font-semibold [&_b]:font-semibold [&_h3]:mb-3 [&_h3]:mt-4 [&_h4]:mb-3 [&_h4]:mt-4 [&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
        memoType.prose
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
